var link_viewer_default = {
  "fontElementMap": "K1bfA",
  "link": "nQVDA",
  "linkInEditor": "imOH1",
  "linkInViewer": "fEmGN",
  "toolbarUrlContainer": "v7DVm",
  "toolbarUrl": "GvCN9",
  "toolbarUrlAnchor": "CTKue"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
